/* Lectura del dashboard guardado.
   El backend distingue tres casos y el frontend debe hacer lo mismo:
   1. Nunca configurado        -> data: null            (configured: false)
   2. Personalizado            -> data con layouts
   3. Guardado intencionalmente vacío -> data con layouts: [] (configured: true)
   Solo el caso 1 podrá mostrar la plantilla predeterminada. */

export const normalizeLayout = (layout = {}) => ({
  ...layout,
  id: layout.id || layout._id,
  slots: Array.isArray(layout.slots) ? layout.slots : [],
});

export const normalizeDashboardPayload = (response) => {
  const root = response?.data?.data ?? response?.data ?? response;
  const dashboard = Array.isArray(root) ? root[0] : root;
  const layouts = Array.isArray(dashboard?.layouts)
    ? dashboard.layouts
    : Array.isArray(root?.layouts)
      ? root.layouts
      : [];

  return {
    dashboardId: dashboard?._id || dashboard?.id || null,
    filters: dashboard?.filters || {},
    layouts: layouts.map(normalizeLayout),
  };
};

/* Estado que se hidrata cuando no hay nada guardado. `saved: true` porque no hay cambios pendientes. */
export const createEmptyDashboardState = () => ({ layouts: [], saved: true, dashboardId: null, isTemplate: false });

/* Interpreta la respuesta de GET /dashboard-layout.
   `configured` es true cuando existe un documento guardado, aunque no tenga bloques. */
export const parseSavedDashboard = (response) => {
  const body = response?.data;
  const hasDocument = Boolean(body?.success && body?.data);
  const configured = hasDocument && body.configured !== false;

  if (!configured) {
    // Never configured: the server may offer the default template. It is shown, not saved: nothing is written until the
    // user edits and saves, and a saved dashboard (even an empty one) never reaches this branch.
    const template = body?.success ? body?.default_template : null;
    if (template && Array.isArray(template.layouts) && template.layouts.length > 0) {
      return {
        configured: false,
        isTemplate: true,
        filters: template.filters || {},
        state: { layouts: template.layouts.map(normalizeLayout), saved: true, dashboardId: null, isTemplate: true },
      };
    }
    return { configured: false, isTemplate: false, filters: {}, state: createEmptyDashboardState() };
  }

  const dashboard = normalizeDashboardPayload(response);
  return {
    configured: true,
    isTemplate: false,
    filters: dashboard.filters,
    state: { layouts: dashboard.layouts, saved: true, dashboardId: dashboard.dashboardId, isTemplate: false },
  };
};
